import { useEffect, useMemo, useState } from "react";
import generateDeliveryOrderPdf from "./generateDeliveryOrderPdf";
import { api } from "./api/api";
import generateReceiptPdf from "./generateReceiptPdf";


function DeliveryOrderScreen({ onBack }) {
  const [bols, setBols] = useState([]);
  const [searchAwb, setSearchAwb] = useState(""); // ✅ new
  const [issueDialogBol, setIssueDialogBol] = useState(null);
  const [issueForm, setIssueForm] = useState({
    doRecipient: "",
    doRecipientPhone: "",
    doReceivedDate: "",
  });
  const [issuing, setIssuing] = useState(false);
  // const API = "http://localhost:3011";

  useEffect(() => {
    loadBols();
  }, []);

  const formatCurrency = (value) => {
  if (value == null) return "N/A";
  return new Intl.NumberFormat("en-US").format(value);
};

const formatWeight = (value) => {
  if (value == null) return "N/A";
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(num);
};



const loadBols = async () => {
  try {
    const data = await api.get("/bols/ready-for-do");

    // ✅ دعم أكثر من شكل للرد
    const list =
      Array.isArray(data) ? data :
      Array.isArray(data?.data) ? data.data :
      Array.isArray(data?.rows) ? data.rows :
      [];

    setBols(list);
  } catch (err) {
    console.error(err);
    setBols([]); // ✅ لا تخليها Object
    alert(err.message || "Failed to load BOLs");
  }
};



const filteredBols = useMemo(() => {
  const list = Array.isArray(bols) ? bols : [];
  const q = searchAwb.trim().toLowerCase();
  if (!q) return list;
  return list.filter((b) =>
    String(b.bol_reference || "").toLowerCase().includes(q)
  );
}, [bols, searchAwb]);


const openIssueDialog = (bol) => {
  const today = new Date().toISOString().slice(0, 10);
  setIssueDialogBol(bol);
  setIssueForm({
    doRecipient: "",
    doRecipientPhone: "",
    doReceivedDate: today,
  });
};

const closeIssueDialog = () => {
  setIssueDialogBol(null);
  setIssueForm({
    doRecipient: "",
    doRecipientPhone: "",
    doReceivedDate: "",
  });
};

const handleIssue = async (bol) => {
  const doRecipient = String(issueForm.doRecipient || "").trim();
  const doRecipientPhone = String(issueForm.doRecipientPhone || "").trim();
  const doReceivedDate = String(issueForm.doReceivedDate || "").trim();

  if (!doRecipient || !doRecipientPhone || !doReceivedDate) {
    alert("Please fill recipient name, phone, and DO received date.");
    return;
  }

  try {
    setIssuing(true);
    // استدعاء API عبر الملف المركزي
    const res = await api.post(`/bols/${bol.bol_id}/issue-do`, {
      doRecipient,
      doRecipientPhone,
      doReceivedDate,
    });

    // تحديث بيانات البوليصة بالبيانات الجديدة (رقم الإيصال والمبلغ الفعلي)
    const updatedBol = {
      ...bol,
      receipt_no: res.receipt_no,
      do_price: res.receipt_amount,
      d_no: res.d_no,
      do_recipient: doRecipient,
      do_recipient_phone: doRecipientPhone,
      do_received_date: doReceivedDate,
    };

    // نفس المنطق السابق بدون تغيير
generateDeliveryOrderPdf({
  bol: updatedBol,
  header: {
    id: bol.header_id,
    manifest_no: bol.manifest_no,   // ✅
    voyage_number: bol.voyage_number,
    date_of_arrival: bol.date_of_arrival,
    place_of_departure_code: bol.place_of_departure_code,
    place_of_destination_code: bol.place_of_destination_code,
    registration: bol.registration,
  },
});

  generateReceiptPdf({ bol: updatedBol });


    setBols((prev) => prev.filter((b) => b.bol_id !== bol.bol_id));
    closeIssueDialog();
    alert(`Delivery Order has been issued ✅ (Receipt No: ${res.receipt_no})`);
  } catch (err) {
    console.error(err);
    alert(err.message || "Failed to issue Delivery Order");
  } finally {
    setIssuing(false);
  }
};


  return (
    <div className="screen screen-rtl">
      <h2>Issue Delivery Order</h2>

      {/* ✅ Search box */}
      <div className="card">
        <div className="grid grid-auto small-gap">
          <div className="field">
            <label>Search by AWB</label>
            <input
              type="text"
              value={searchAwb}
              onChange={(e) => setSearchAwb(e.target.value)}
              placeholder="Type AWB reference..."
            />
          </div>

          <div className="field">
            <label>Results</label>
            <input value={filteredBols.length} readOnly />
          </div>

          <div className="field" style={{ alignSelf: "end" }}>
            <button type="button" onClick={() => setSearchAwb("")}>
              Clear
            </button>
          </div>
        </div>
      </div>

      <div className="table-scroll-y">
      <div className="table-wrap">

      <table className="data-table">
        <thead>
          <tr>
            <th>AWB</th>
            <th>Consignee</th>
            <th>Weight</th>
            <th>Price</th>
            <th>Delivery Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredBols.map((bol) => (
            <tr key={bol.bol_id}>
              <td>
  <div style={{ lineHeight: 1.2 }}>
    <div>{bol.bol_reference}</div>

    {/* لو في HAWB اعرض MAWB تحتها */}
    {bol.hawb_no ? (
      <div style={{ fontSize: 12, opacity: 0.85 }}>
        MAWB: {bol.mawb_no || "—"}
      </div>
    ) : null}
  </div>
</td>

              <td>{bol.consignee_name}</td>
              <td>{formatWeight(bol.gross_mass)}</td>
<td>{formatCurrency(bol.do_price)}</td>
              <td>{bol.delivery_date}</td>
              <td>
                <button onClick={() => openIssueDialog(bol)}>Generate DO</button>
              </td>
            </tr>
          ))}

          {filteredBols.length === 0 && (
            <tr>
              <td colSpan={6} style={{ padding: "1rem" }}>
                No matching AWBs.
              </td>
            </tr>
          )}
        </tbody>
      </table>
        </div>
</div>

      {issueDialogBol && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "1rem",
          }}
          onClick={closeIssueDialog}
        >
          <div
            className="card"
            style={{
              width: "min(720px, 100%)",
              maxHeight: "90vh",
              overflowY: "auto",
              border: "1px solid #d7d7d7",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginTop: 0 }}>DO Recipient Details</h3>
            <div style={{ marginBottom: "0.75rem", opacity: 0.9 }}>
              AWB: <strong>{issueDialogBol.bol_reference}</strong>
            </div>

            <div className="grid grid-auto small-gap">
              <div className="field">
                <label>DO Recipient</label>
                <input
                  type="text"
                  value={issueForm.doRecipient}
                  onChange={(e) => setIssueForm((prev) => ({ ...prev, doRecipient: e.target.value }))}
                  placeholder="Enter recipient name"
                />
              </div>

              <div className="field">
                <label>Recipient Phone</label>
                <input
                  type="text"
                  value={issueForm.doRecipientPhone}
                  onChange={(e) => setIssueForm((prev) => ({ ...prev, doRecipientPhone: e.target.value }))}
                  placeholder="Enter phone number"
                />
              </div>

              <div className="field">
                <label>DO Received Date</label>
                <input
                  type="date"
                  value={issueForm.doReceivedDate}
                  onChange={(e) => setIssueForm((prev) => ({ ...prev, doReceivedDate: e.target.value }))}
                />
              </div>
            </div>

            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.75rem" }}>
              <button type="button" onClick={() => handleIssue(issueDialogBol)} disabled={issuing}>
                {issuing ? "Generating..." : "Confirm & Generate DO"}
              </button>
              <button type="button" onClick={closeIssueDialog} disabled={issuing}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeliveryOrderScreen;
